// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1JkkV","info":"UpdateTermsInfo_info__3se2g"};